import { createListApiSchema } from '../General/schemas';
import z from 'zod';

export const documentTypeModelsEnum = z.enum(['users', 'groups', 'events']);
export const documentTypeParsingMethodEnum = z.enum([
	'blink-id',
	'document-api',
	'document-parser',
	'manual',
	'ai-api',
	'agentic',
]);
export const documentTypeExternalSourceEnum = z.enum(['BeSaCC']);

export const externalSourceSchema = z.object({
	source: documentTypeExternalSourceEnum,
	externalId: z.string().optional(),
});

export const documentTypeSchema = z
	.object({
		id: z.string(),
		name: z.string(),
		type: z.string(),
		models: z.array(documentTypeModelsEnum).optional(),
		sensitive: z.boolean(),
		description: z.string().optional(),
		allowedFormats: z.string().optional(),
		parsingMethod: documentTypeParsingMethodEnum.optional(),
		aliases: z.array(z.string()).optional(),
		prompt: z.string().optional(),
		defaultInReview: z.boolean(),
		hasExpiryDate: z.boolean(),
		externalSources: z.array(externalSourceSchema).optional(),
	})
	.describe('DocumentType');

export const documentTypesApiResponseSchema = createListApiSchema(documentTypeSchema).describe('DocumentTypeList');
